import { Box, Paper, Skeleton, Stack, styled } from "@mui/material";
import { BodyTextM, HeadingL, HeadingS } from "../Typography";

export const PageWrapper = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    margin: "5px auto",
    width: "100%",
    textAlign: "left",
}));

export const ColumnsWrapper = styled(Stack)(({ theme }) => ({
    display: "grid",
    gap: theme.spacing(5),
    marginBottom: theme.spacing(7),
    [theme.breakpoints.up("md")]: {
        gridTemplateColumns: "1fr 1fr",
    },
}));

export const Column = styled(Stack)({
    display: "flex",
    flexDirection: "column",
    gap: 5,
});

export const SectionHeaderStack = styled(Stack)(({ theme }) => ({
    display: "flex",
    marginBottom: theme.spacing(1),
    flexDirection: "row",
}));

export const EditTriggerWrapper = styled(Stack)(({ theme }) => ({
    marginTop: theme.spacing(4),
}));

export const DocumentsSection = styled(Stack)(({ theme }) => ({
    marginBottom: theme.spacing(5),
}));

export const PageTitle = styled(HeadingL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(7),
}));

export const IntroParagraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(7),
}));

export const SectionHeadingBold = styled(HeadingS)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));
export const SectionBodyRegular = styled(BodyTextM)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightRegular,
    marginLeft: theme.spacing(2),
}));

export const DocumentsHeading = styled(HeadingS)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
}));

export const DocumentsParagraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(6),
}));

export const AgreementParagraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const AgreementPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
}));

export const DownloadsSkeleton = styled((props: React.ComponentProps<typeof Box>) => (
    <Box {...props}>
        <Skeleton variant="text" width={260} height={24} />
        <Skeleton variant="text" width={180} height={20} />
    </Box>
))(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0, 1),
}));
